import styled from 'styled-components';
import { EvidenceSearchFormWrapper, WhiteWrapper } from 'pages/SalesSettlement/styles';

export const SearchFilterBar = styled(EvidenceSearchFormWrapper)`
  .ant-select.ant-select-single.ant-select-show-arrow .ant-select-selector .ant-select-selection-placeholder {
    line-height: 38px;
  }
`;

export const TableCard = styled(WhiteWrapper)`
  .ant-table-row:hover {
    cursor: default;
  }
`;
